/*
 * -----------------------------------------------------------------------
 *  <copyright file="grid-header-cell/index.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { HeaderThElement } from '@progress/kendo-react-data-tools';
import {
    GridColumnMenuWrapper,
    GridColumnMenuProps,
    GridCustomHeaderCellProps,
} from '@progress/kendo-react-grid';

import { filterIcon } from '@progress/kendo-svg-icons';
import cn from 'clsx';
import React, { ComponentType } from 'react';
import { IExpandableGridColumnV2 } from '../interfaces-v2/grid-props-v2.interface';

interface GridHeaderCellPropsInterface {
    cellProps: GridCustomHeaderCellProps;
    column: IExpandableGridColumnV2;
    filter: CompositeFilterDescriptor;
    columnMenu?: ComponentType<GridColumnMenuProps> | null;
}

const GridHeaderCell = ({ cellProps, column, filter, columnMenu }: GridHeaderCellPropsInterface) => {
    return (
        <HeaderThElement
            columnId={cellProps.thProps?.columnId || ''}
            {...cellProps.thProps}
            className={cn(cellProps.thProps?.className)}
        >
            {!column.notFilterable && (
                <div data-testid={`column-heading-${column.id || column.field}`}>
                    <GridColumnMenuWrapper
                        {...cellProps.columnMenuWrapperProps}
                        columnMenuIcon={filterIcon}
                        columnMenu={columnMenu}
                    />
                </div>
            )}
            <a
                title={column.tooltipValue}
                id={`title-${column.id || column.field}`}
                onClick={() => {
                    cellProps.onClick();
                }}
                className={`header-cell ${column.headerClass || ''}
                ${column.notSortable && column.notFilterable ? 'full-width' : ''}`}
            >
                <span className={`k-w-full ${column.isWrapHeader ? 'wrap-text' : ''}`} title={column.tooltipValue}>
                    {cellProps.children}
                </span>
            </a>
        </HeaderThElement>
    );
};

export default GridHeaderCell;
